import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const FormatProductItemProductFragmentDoc = gql`
  fragment FormatProductItemProduct on ProductInterface {
    id
    itemSize
    itemMeasure
    concatenatedSellUnit
    itemPackName
    itemSellQuantity
  }
` as unknown as DocumentNode<Types.FormatProductItemProductFragment, unknown>
